import type { FaireProductEntity } from "../../entity_types/product";

export const p_cew4ou0676: FaireProductEntity = {
  token: "p_cew4ou0676",
  type: "product",
  name: "29 PALMS",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl: "https://cdn.faire.com/fastly/3d01a16a57f0f1d9850ad3d5ca923686b02fea3431bd52b8e6f7ee5ba27bd1c9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2a5556cd7be3b2c76636cf9bbff54eaf89261ba544d1deb02ade862d6ffe37aa.jpeg",
    "https://cdn.faire.com/fastly/53d012cf6d76f5b8cf288a076c649f12d4c2217e23739b9ef5d9cda085c19099.jpeg"
  ],
  priceDollars: 18,
  description: "Capturing the essence of the cool morning desert air after rainfall. Pure and simple in nature, this scent opens with the soothing fragrance of eucalyptus and desert sage atop woody base notes of cedar and palo santo and finished with the delicate nuance of rain accord.\n\ndesert sage, cedar, eucalyptus, palo santo, white musk\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n\n7 ounces (198g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:05:09.016Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
